module.exports = {"All":"All of the following","One":"One of the following","LessThan":"Less Than","LessThanOrEqualTo":"Less Than Or Equal To","GreaterThan":"Greater Than","GreaterThanOrEqualTo":"Greater Than Or Equal To","EqualTo":"Equal To","NotEqualTo":"Not Equal To","Is":"Is","IsNot":"Is Not"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/operator-type.json
// module id = bA1O
// module chunks = 12